/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CrmProjectEventActorData } from './CrmProjectEventActorData';
import {
    CrmProjectEventActorDataFromJSON,
    CrmProjectEventActorDataFromJSONTyped,
    CrmProjectEventActorDataToJSON,
    CrmProjectEventActorDataToJSONTyped,
} from './CrmProjectEventActorData';

/**
 * 
 * @export
 * @interface CrmProjectEventData
 */
export interface CrmProjectEventData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectEventData
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectEventData
     */
    occurredAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectEventData
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectEventData
     */
    entityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectEventData
     */
    operation?: string;
    /**
     * 
     * @type {object}
     * @memberof CrmProjectEventData
     */
    before?: object | null;
    /**
     * 
     * @type {object}
     * @memberof CrmProjectEventData
     */
    after?: object | null;
    /**
     * 
     * @type {CrmProjectEventDataSourceEnum}
     * @memberof CrmProjectEventData
     */
    source?: CrmProjectEventDataSourceEnum;
    /**
     * 
     * @type {CrmProjectEventActorData}
     * @memberof CrmProjectEventData
     */
    actor?: CrmProjectEventActorData;
}


/**
 * @export
 */
export const CrmProjectEventDataSourceEnum = {
    Crm: 'crm',
    SubscriptionAudit: 'subscription_audit'
} as const;
export type CrmProjectEventDataSourceEnum = typeof CrmProjectEventDataSourceEnum[keyof typeof CrmProjectEventDataSourceEnum];


/**
 * Check if a given object implements the CrmProjectEventData interface.
 */
export function instanceOfCrmProjectEventData(value: object): value is CrmProjectEventData {
    return true;
}

export function CrmProjectEventDataFromJSON(json: any): CrmProjectEventData {
    return CrmProjectEventDataFromJSONTyped(json, false);
}

export function CrmProjectEventDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectEventData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'occurredAt': json['occurredAt'] == null ? undefined : (new Date(json['occurredAt'])),
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] === undefined ? undefined : json['entityId'] === null ? null : json['entityId'],
        'operation': json['operation'] == null ? undefined : json['operation'],
        'before': json['before'] === undefined ? undefined : json['before'] === null ? null : json['before'],
        'after': json['after'] === undefined ? undefined : json['after'] === null ? null : json['after'],
        'source': json['source'] == null ? undefined : json['source'],
        'actor': json['actor'] == null ? undefined : CrmProjectEventActorDataFromJSON(json['actor']),
    };
}

export function CrmProjectEventDataToJSON(json: any): CrmProjectEventData {
    return CrmProjectEventDataToJSONTyped(json, false);
}

export function CrmProjectEventDataToJSONTyped(value?: CrmProjectEventData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'occurredAt': value['occurredAt'] == null ? value['occurredAt'] : value['occurredAt'].toISOString(),
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'operation': value['operation'],
        'before': value['before'],
        'after': value['after'],
        'source': value['source'],
        'actor': CrmProjectEventActorDataToJSON(value['actor']),
    };
}

